module.exports = __webpack_public_path__ + "img/order5.16e13d76.png";